module.exports = __webpack_public_path__ + "img/404.8e8f7131.png";